import './PromissoryNoteGroup.scss';
import React from 'react';
import PromissoryNoteTemplate from './components/PromissoryNoteTemplate';
import RequisitionModel from '../../../models/RequisitionModel';
import formatString from '../../../utilities/format-string';
import Signatures from '../components/Signatures';
import SignaturePlaceDate from '../components/SignaturePlaceDate';

const PromissoryNoteGroup = ({ requisition }) => {
  const borrowerName = requisition?.Grupo?.nombre;

  const total = RequisitionModel.getTotalAmountByType(
    'monto_autorizado',
    requisition?.montos
  );
  const formattedTotal = formatString.setLegiblePrice(total);

  const totalLetter = formatString.convertNumbersToLetters(total);

  const totalAmmout = `${formattedTotal} (${totalLetter} 00/100 M.N.)`;

  const address = `${requisition?.Sucursal.direccion}, ${requisition?.Sucursal.nombre}, ${requisition?.Sucursal.entidad_federativa}`;

  const socios = requisition?.Grupo.Socios ?? [];

  const isGroup = socios.length > 1 ? true : false;

  const date = formatString.setLegibleDatePlainText(
    requisition.fecha_elaboracion.iso
  );

  return (
    <div className="document-promissory-note afterClass">
      <PromissoryNoteTemplate
        totalAmount={totalAmmout}
        isGroup
        borrowerName={borrowerName}
        address={address}
      />

      <div>
        <p>
          {isGroup ? 'ACEPTAMOS' : 'ACEPTO'} PAGAR A SU VENCIMIENTO EN FORMA
          SOLIDARIA:
        </p>

        <Signatures socios={socios} />

        <div style={styles.space} />

        <SignaturePlaceDate date={date} address={address} />
      </div>
    </div>
  );
};

export default PromissoryNoteGroup;

const styles = {
  space: {
    marginTop: '15pt',
  },
};
